var messageLengthValid = true;

$(function () {
    $('.ProductQuantityControl--input').on('keyup paste blur', function () {
        var input = $(this);
        var val = parseInt(input.val());
        var min = parseInt(input.attr('min'));
        var max = parseInt(input.attr('max'));
        var minusButton = input.parents('.ProductQuantityControl').find('.ProductQuantityControl--minus');
        var plusButton = input.parents('.ProductQuantityControl').find('.ProductQuantityControl--plus');

        setTimeout(function () {
            minusButton.prop('disabled', false);
            plusButton.prop('disabled', false);

            if (val <= min) {
                input.val(min);
                minusButton.prop('disabled', true);
            }
            if (val >= max) {
                input.val(max);
                plusButton.prop('disabled', true);
            }
            input.parents('form').trigger('submit');
        }, 0);
    }).trigger('keyup');

    $('.ProductQuantityControl--minus').on('click', function () {
        var input = $(this).parents('.ProductQuantityControl').find('.ProductQuantityControl--input');
        var val = parseInt(input.val());
        var min = parseInt(input.attr('min'));

        if (val > min) {
            input.val(val - 1).trigger('keyup');
        }
    });

    $('.ProductQuantityControl--plus').on('click', function () {
        var input = $(this).parents('.ProductQuantityControl').find('.ProductQuantityControl--input');
        var val = parseInt(input.val());
        var max = parseInt(input.attr('max'));

        if (val < max) {
            input.val(val + 1).trigger('keyup');
        }
    });

    $('.BeginCheckout').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var subscriptionProducts = [];
        $('.subscription-product-data').each(function (i, el) {
            subscriptionProducts.push($.parseJSON($(el).text()));
        });
        var subscriptionProductItems = $.map(subscriptionProducts, function (subscriptionProduct, i) {
            return {
                'id': subscriptionProduct.gaId,
                'name': subscriptionProduct.gaName,
                'variant': subscriptionProduct.gaVariant,
                'price': subscriptionProduct.gaPrice,
                'quantity': 1
            };
        });

        var shopProducts = [];
        var shopProductQtys = [];
        $('.shop-product-data').each(function (i, el) {
            var qty = $(el).siblings('.ProductQuantityControl').find('.ProductQuantityControl--input').val();
            shopProducts.push($.parseJSON($(el).text()));
            shopProductQtys.push(qty);
        });
        var shopProductItems = $.map(shopProducts, function (shopProduct, i) {
            return {
                'id': shopProduct.gaId,
                'name': shopProduct.gaName,
                'price': shopProduct.gaPrice,
                'quantity': shopProductQtys[i]
            };
        });

        var items = subscriptionProductItems.concat(shopProductItems);

        gtag('event', 'begin_checkout', {
            'items': items,
            'event_callback': createFunctionWithTimeout(function () {
                window.location = target;
            })
        });
    });

    $('select[name$="CountryCode"]').on('change', function () {
        $(this).parents('form').find('input[name$="Postcode"]').trigger('blur'); // re-validate postcode
    });

    $('.fieldGroup__edit').on('click', function () {
        $('.fieldGroup form:not(.collapsed, #EventOptionsForm)').slideUp(function () {
            $(this).addClass('collapsed');
        });
        var fieldGroup = $(this).parents('.fieldGroup');
        fieldGroup.find('.fieldGroup__summaryRow').slideUp(function () {
            $(this).addClass('hidden');
            fieldGroup.find('form').removeClass('collapsed').hide().slideDown();
        });
        $(this).fadeOut().addClass('hidden');
        fieldGroup.nextAll('.fieldGroup').find('.fieldGroup__edit').fadeOut(function () {
            $(this).addClass('hidden');
        });
        fieldGroup.nextAll('.fieldGroup').find('.fieldGroup__summaryRow').slideUp(function () {
            $(this).addClass('hidden');
        });
    });

    $('.orderDetails__edit').on('click', function () {
        $(this).fadeOut(function () {
            $(this).addClass('hidden');
            $(this).siblings('.orderDetails__cancel').removeClass('hidden').hide().fadeIn();
        });
        var orderDetailsBlock = $(this).parents('.orderDetails__block');
        orderDetailsBlock.find('.orderDetails__current').fadeOut(function () {
            $(this).addClass('collapsed');
            orderDetailsBlock.find('.orderDetails__form').removeClass('collapsed').hide().fadeIn();
        });
    });

    $('.orderDetails__cancel').on('click', function () {
        $(this).fadeOut(function () {
            $(this).addClass('hidden');
            $(this).siblings('.orderDetails__edit').removeClass('hidden').hide().fadeIn();
        });
        var orderDetailsBlock = $(this).parents('.orderDetails__block');
        orderDetailsBlock.find('.orderDetails__form').fadeOut(function () {
            $(this).addClass('collapsed');
            orderDetailsBlock.find('.orderDetails__current').removeClass('collapsed').hide().fadeIn();
        });
    });

    $('.orderDetails__boxAddressContainer').hover(function () {
        $(this).children('.orderDetails__boxAddress').stop().removeClass('d-none').hide().fadeIn();
    }, function () {
        $(this).children('.orderDetails__boxAddress').stop().fadeOut(function () {
            $(this).addClass('d-none');
        });
    });

    var previewModalWindowHeightInterval;

    $('#previewModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var type = button.data('type');
        var action = button.data('action');
        var guid = button.data('guid');
        var token = button.data('token');

        $('#previewModal').data('page', '1');
        $('#previewModal .modal-title span').addClass('d-none');

        switch (type) {
            case "subscription":
                $('#previewModalSubscriptionLabel1').removeClass('d-none');
                $('#previewModalPrev, #previewModalNext, #previewModalPageIndicators').removeClass('d-none')

                $('#previewModalPrev').addClass('disabled');
                $('#previewModalNext').removeClass('disabled');
                $('#previewModal .page-indicator').removeClass('active');
                $('#previewModalPageIndicator1').addClass('active');
                break;

            case "gift-box":
                $('#previewModalGiftBoxLabel').removeClass('d-none');
                $('#previewModalPrev, #previewModalNext, #previewModalPageIndicators').addClass('d-none')
                break;
        }
        $('#previewModal .previewModal--embed').empty();
        $('#previewModal .previewModal--loading').show();

        $.post(action, { guid: guid, __RequestVerificationToken: token }, function (data) {
            if (data.success) {
                var object = $('<object />').attr('data', data.certificateUrl).attr('type', 'application/pdf').attr('width', '100%').attr('height', getAvailableHeightForModal()).on('load', function () {
                    $('#previewModal .previewModal--loading').hide();
                });
                var iframe = $('<iframe />').attr('src', data.certificateUrl).css('border', 'none').attr('width', '100%').attr('height', '100%').on('load', function () {
                    $('#previewModal .previewModal--loading').hide();
                });
                var link = $('<a />').attr('href', data.certificateUrl).text('Download PDF');
                iframe.text('Your browser does not support viewing PDFs. Please download your certificate preview to view it: ').append(link);
                object.append(iframe);

                $('#previewModal .previewModal--embed').append(object).data('certificateUrl', data.certificateUrl).data('firstInsertUrl', data.firstInsertUrl).data('subsequentInsertUrl', data.subsequentInsertUrl);
            }
        });
    }).on('shown.bs.modal', function () {
        $('#previewModal .previewModal--embed object').attr('height', getAvailableHeightForModal());
        var windowHeight = $(window).height();
        previewModalWindowHeightInterval = window.setInterval(function () {
            if (windowHeight !== $(window).height()) {
                windowHeight = $(window).height();
                if ($('#previewModal').is(':visible')) {
                    $('#previewModal .previewModal--embed object').attr('height', getAvailableHeightForModal());
                }
            }
        }, 100);
    }).on('hide.bs.modal', function () {
        window.clearInterval(previewModalWindowHeightInterval);
    });

    $('#previewModalPrev').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('disabled')) {
            $('#previewModal .modal-title span').addClass('d-none');
            $('#previewModal .page-indicator').removeClass('active');
            $('#previewModal .previewModal--loading').show();
            switch ($('#previewModal').data('page')) {
                case '2':
                    $('#previewModal').data('page', '1');
                    $('#previewModalSubscriptionLabel1').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('certificateUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalPrev').addClass('disabled');
                    $('#previewModalPageIndicator1').addClass('active');
                    break;
                case '3':
                    $('#previewModal').data('page', '2');
                    $('#previewModalSubscriptionLabel2').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('firstInsertUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalNext').removeClass('disabled');
                    $('#previewModalPageIndicator2').addClass('active');
                    break;
            }
        }
    });

    $('#previewModalNext').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('disabled')) {
            $('#previewModal .modal-title span').addClass('d-none');
            $('#previewModal .page-indicator').removeClass('active');
            $('#previewModal .previewModal--loading').show();
            switch ($('#previewModal').data('page')) {
                case '1':
                    $('#previewModal').data('page', '2');
                    $('#previewModalSubscriptionLabel2').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('firstInsertUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalPrev').removeClass('disabled');
                    $('#previewModalPageIndicator2').addClass('active');
                    break;
                case '2':
                    $('#previewModal').data('page', '3');
                    $('#previewModalSubscriptionLabel3').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('subsequentInsertUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalNext').addClass('disabled');
                    $('#previewModalPageIndicator3').addClass('active');
                    break;
            }
        }
    });

    $('#previewModal .page-indicator').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $('#previewModal .modal-title span').addClass('d-none');
            $('#previewModal .page-indicator').removeClass('active');
            $('#previewModal .previewModal--loading').show();
            switch ($(this).attr('id')) {
                case 'previewModalPageIndicator1':
                    $('#previewModal').data('page', '1');
                    $('#previewModalSubscriptionLabel1').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('certificateUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalPrev').addClass('disabled');
                    $('#previewModalNext').removeClass('disabled');
                    $('#previewModalPageIndicator1').addClass('active');
                    break;
                case 'previewModalPageIndicator2':
                    $('#previewModal').data('page', '2');
                    $('#previewModalSubscriptionLabel2').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('firstInsertUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalPrev').removeClass('disabled');
                    $('#previewModalNext').removeClass('disabled');
                    $('#previewModalPageIndicator2').addClass('active');
                    break;
                case 'previewModalPageIndicator3':
                    $('#previewModal').data('page', '3');
                    $('#previewModalSubscriptionLabel3').removeClass('d-none');
                    $('#previewModal .previewModal--embed object').attr('data', $('#previewModal .previewModal--embed').data('subsequentInsertUrl')).on('load', function () {
                        $('#previewModal .previewModal--loading').hide();
                    });
                    $('#previewModalPrev').removeClass('disabled');
                    $('#previewModalNext').addClass('disabled');
                    $('#previewModalPageIndicator3').addClass('active');
                    break;
            }
        }
    });
});

function getAvailableHeightForModal() {
    return $(window).height()
        - parseFloat($('.modal-dialog:visible').css('margin-top'))
        - parseFloat($('.modal-dialog:visible').css('margin-bottom'))
        - $('.modal-header:visible').outerHeight()
        - parseFloat($('.modal-body:visible').css('padding-top'))
        - parseFloat($('.modal-body:visible').css('padding-bottom'))
        - 10
        + 'px';
}

function voucherCodeAJAXDone(data) {
    //console.log("voucherCodeAJAXDone");
    //console.log(data);
    if (data.status == null || data.status != 200) {
        location.reload();
    } else {
        if (data.responseJSON.errorRedirectUrl != null) {
            window.location = data.responseJSON.errorRedirectUrl;
        } else if (data.responseJSON.errorMessage != null) {
            alert(data.responseJSON.errorMessage);
            $('.voucherDiscountRow').addClass('d-none');
        } else {
            $('.voucherDiscount').text(accounting.formatMoney(data.responseJSON.cart.discountAmount, '£'));
            $('.orderTotal').text(accounting.formatMoney(data.responseJSON.cart.total, '£'));
            $('.voucherCodeTB').val('');
            $('.voucherNameDisplay').text(data.responseJSON.cart.voucher.name);
            if (data.responseJSON.cart.referralVoucherCode != null) {
                $('.voucherCodeDisplay').text(data.responseJSON.cart.referralVoucherCode);
            } else {
                $('.voucherCodeDisplay').text(data.responseJSON.cart.voucher.code);
            }
            $('.initialVoucherForm').addClass('d-none');
            $('.secondaryVoucherForm, .voucherDiscountRow').removeClass('d-none');
        }
    }
}

function voucherCodeAJAXDeleteDone(data) {
    //console.log("voucherCodeAJAXDeleteDone");
    if (data == null || data.status != 200) {
        location.reload();
    } else {
        if (data.responseJSON.errorRedirectUrl != null) {
            window.location = data.responseJSON.errorRedirectUrl;
        } else {
            $('.voucherDiscount').text(accounting.formatMoney(data.responseJSON.cart.discountAmount, '£'));
            $('.orderTotal').text(accounting.formatMoney(data.responseJSON.cart.total, '£'));
            $('.voucherCodeTB').val('');
            $('.initialVoucherForm').removeClass('d-none');
            $('.secondaryVoucherForm, .voucherDiscountRow').addClass('d-none');
        }
    }
}

function ChangeProductQuantityComplete(data) {
    if (data.status == null || data.status != 200) {
        location.reload();
    } else {
        if (data.responseJSON.errorRedirectUrl != null) {
            window.location = data.responseJSON.errorRedirectUrl;
        } else {
            $('.cart-item-count').text(data.responseJSON.cart.itemCount);
            $('.voucherDiscount').text(accounting.formatMoney(data.responseJSON.cart.discountAmount, '£'));
            $('.orderSubtotal').text(accounting.formatMoney(data.responseJSON.cart.subtotal, '£'));
            $('.orderTotal').text(accounting.formatMoney(data.responseJSON.cart.total, '£'));
            $.each(data.responseJSON.cart.shopProducts, function (i, product) {
                var productRow = $('.ShopProductRow[data-guid="' + product.guid + '"]');
                productRow.find('.shopProductPrice').text(accounting.formatMoney(product.price, '£'));
                if (product.quantity > 1) {
                    productRow.find('.shopProductEachPrice ').removeClass('d-none');
                } else {
                    productRow.find('.shopProductEachPrice ').addClass('d-none');
                }
            });
        } 
    }
}

function BillingComplete(data) {
    var cardElement = $('#card-element');
    var cardErrors = $('#card-errors');

    if (data == null || data.status != 200) {
        location.reload();
    } else {
        if (data.responseJSON.success) {
            if (data.responseJSON.freeOrder) {
                window.location = data.responseJSON.redirectUrl;
            } else {
                var payButton = $('.payButton');
                var clientSecret = payButton.data('secret');

                stripe.handleCardPayment(
                    clientSecret, card, {
                    payment_method_data: {
                        billing_details: {
                            name: $.trim($('input[name="Cart.BillingAddress.Name"]').val()),
                            address: {
                                line1: $.trim($('input[name="Cart.BillingAddress.Line1"]').val()),
                                line2: $.trim($('input[name="Cart.BillingAddress.Line2"]').val()),
                                city: $.trim($('input[name="Cart.BillingAddress.TownCity"]').val()),
                                postal_code: $.trim($('input[name="Cart.BillingAddress.Postcode"]').val()),
                                country: $.trim($('select[name="Cart.BillingAddress.CountryCode"]').val())
                            }
                        }
                    },
                    save_payment_method: true
                }
                ).then(function (result) {
                    if (result.error) {
                        cardElement.addClass('StripeElement--invalid');
                        cardErrors.removeClass('field-validation-valid').addClass('field-validation-error').text(result.error.message);
                        $('button').prop('disabled', false);
                        $('a.btn').removeClass('disabled');
                        $('.payButton .fas').addClass('fa-lock-alt').removeClass('fa-circle-notch fa-spin');
                    } else {
                        window.location = data.responseJSON.redirectUrl;
                    }
                });
            }
        } else {
            if (data.responseJSON.errorRedirectUrl != null) {
                window.location = data.responseJSON.errorRedirectUrl;
            } else {
                cardElement.removeClass('StripeElement--invalid');
                cardErrors.removeClass('field-validation-error').addClass('field-validation-valid').text('');

                alert('An error occurred. Please check your details and try again.');
            }
            $('button').prop('disabled', false);
            $('a.btn').removeClass('disabled');
            $('.payButton .fas').addClass('fa-lock-alt').removeClass('fa-circle-notch fa-spin');
        }
    }
}

function EditDeliveryAddressComplete(data) {
    if (data.responseJSON.success) {
        $('.orderDetails__form.EditDeliveryAddress').each(function () {
            var form = $(this);
            if (form.find('input[name="Guid"]').val() == data.responseJSON.guid) {
                var orderDetailsBlock = form.parents('.orderDetails__block');
                orderDetailsBlock.find('.DeliveryAddressName').text(data.responseJSON.name);
                orderDetailsBlock.find('.DeliveryAddress').text(data.responseJSON.address);
                form.fadeOut(function () {
                    form.addClass('collapsed');
                    orderDetailsBlock.find('.orderDetails__current').removeClass('collapsed').hide().fadeIn();
                });
                var cancelButton = orderDetailsBlock.find('.orderDetails__cancel');
                cancelButton.fadeOut(function () {
                    $(this).addClass('hidden');
                    $(this).siblings('.orderDetails__edit').removeClass('hidden').hide().fadeIn();
                });
            }
        });
    }
}

function EditFirstDeliveryComplete(data) {
    if (data.responseJSON.success) {
        $('.orderDetails__form.EditFirstDelivery').each(function () {
            var form = $(this);
            if (form.find('input[name="Guid"]').val() == data.responseJSON.guid) {
                var orderTracking = form.parents('.orderDetails').find('.orderDetails__tracking');
                orderTracking.find('.DespatchDate').each(function (i, e) {
                    $(e).text(data.responseJSON.despatchDates[i]);
                });

                var orderDetailsBlock = form.parents('.orderDetails__block');
                orderDetailsBlock.find('.DespatchDate').text(data.responseJSON.despatchDates[0]);
                orderDetailsBlock.find('.FirstBoxSendTo').text(data.responseJSON.to);
                orderDetailsBlock.find('.DoNotOpenUntil').text(data.responseJSON.doNotOpenUntil);
                orderDetailsBlock.find('.FirstBoxDeliveryAddressName').text(data.responseJSON.name);
                orderDetailsBlock.find('.FirstBoxDeliveryAddress').text(data.responseJSON.address);
                if (data.responseJSON.to.toLowerCase() == 'me') {
                    orderDetailsBlock.find('.firstBoxToMe--show').removeClass('collapsed');
                    orderDetailsBlock.find('.firstBoxToMe--hide').addClass('collapsed');
                } else {
                    orderDetailsBlock.find('.firstBoxToMe--show').addClass('collapsed');
                    orderDetailsBlock.find('.firstBoxToMe--hide').removeClass('collapsed');
                }
                form.fadeOut(function () {
                    form.addClass('collapsed');
                    orderDetailsBlock.find('.orderDetails__current').removeClass('collapsed').hide().fadeIn();
                });
                var cancelButton = orderDetailsBlock.find('.orderDetails__cancel');
                cancelButton.fadeOut(function () {
                    $(this).addClass('hidden');
                    $(this).siblings('.orderDetails__edit').removeClass('hidden').hide().fadeIn();
                });
            }
        });
    }
}

function EditPersonalMessageComplete(data) {
    if (data.responseJSON.success) {
        $('.orderDetails__form.EditPersonalMessage').each(function () {
            var form = $(this);
            if (form.find('input[name="Guid"]').val() == data.responseJSON.guid) {
                var orderDetailsBlock = form.parents('.orderDetails__block');
                orderDetailsBlock.find('.PersonalMessage').text(data.responseJSON.message);
                form.fadeOut(function () {
                    form.addClass('collapsed');
                    orderDetailsBlock.find('.orderDetails__current').removeClass('collapsed').hide().fadeIn();
                });
                var cancelButton = orderDetailsBlock.find('.orderDetails__cancel');
                cancelButton.fadeOut(function () {
                    $(this).addClass('hidden');
                    $(this).siblings('.orderDetails__edit').removeClass('hidden').hide().fadeIn();
                });
            }
        });
    }
}

function EditProductDetailsComplete(data) {
    if (data.responseJSON.success) {
        $('.orderDetails__form.EditProductDetails').each(function () {
            var form = $(this);
            if (form.find('input[name="Guid"]').val() == data.responseJSON.guid) {
                var orderDetailsBlock = form.parents('.orderDetails__block');
                orderDetailsBlock.find('.ProductName').text(data.responseJSON.productName);
                orderDetailsBlock.find('.SubscriptionLength').text(data.responseJSON.subscriptionLength);
                orderDetailsBlock.find('.Total').text(data.responseJSON.total);
                var orderDetailsCurrent = orderDetailsBlock.find('.orderDetails__current');
                orderDetailsCurrent.find('.row.Message').remove();
                if (data.responseJSON.message != null) {
                    orderDetailsCurrent.append($('<div />').addClass('row Message').append($('<div />').addClass('col').html(data.responseJSON.message)));
                }

                var orderDetailsTrackingBlock = form.parents('.orderDetails').find('.orderDetails__tracking');
                orderDetailsTrackingBlock.find('.row:not(.orderDetails__headerRow, .orderDetails__boxDispatched)').remove();
                $.each(data.responseJSON.boxes, function (i, box) {
                    if (box.actualDespatchDate == null) {
                        var row = $('<div />').addClass('row no-gutters');
                        var col1 = $('<div />').addClass('col-3 col-sm-2');
                        var boxInfo1 = $('<div />').addClass('orderDetails__boxInfo orderDetails__boxInfo--boxNumber').html('Box ' + box.month);
                        col1.append(boxInfo1)
                        var col2 = $('<div />').addClass('col-9 col-sm-10');
                        var boxInfo2 = $('<div />').addClass('orderDetails__boxInfo');
                        var skus = $.map(box.components, function (el, i) {
                            return el.productComponentSku;
                        }).join(', ');
                        var boxInfo2Content = $('<span />').html(skus + ' Dispatching on ');
                        var boxInfo2DespatchDate = $('<span />').addClass('DespatchDate').html(formatDateNicely(new Date(box.despatchDate)));
                        boxInfo2Content.append(boxInfo2DespatchDate);
                        boxInfo2.append(boxInfo2Content);
                        col2.append(boxInfo2);
                        row.append(col1, col2);
                        orderDetailsTrackingBlock.append(row);
                    }
                });

                form.find('select[name="ProductOptionId"]').attr('data-selected', data.responseJSON.productOptionId);
                form.fadeOut(function () {
                    form.addClass('collapsed');
                    orderDetailsBlock.find('.orderDetails__current').removeClass('collapsed').hide().fadeIn();
                });
                var cancelButton = orderDetailsBlock.find('.orderDetails__cancel');
                cancelButton.fadeOut(function () {
                    $(this).addClass('hidden');
                    $(this).siblings('.orderDetails__edit').removeClass('hidden').hide().fadeIn();
                });
            }
        });
    }
}